import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";

export default function EditCapacityAction({ activeCarrier, originPoint, lane, actionCallback }) {
  return (
    <StyledTooltip title="Edit">
      <Box>
        <InlineIconButton
          onClick={() => {
            localStorage.setItem("lane", JSON.stringify(lane));

            actionCallback({ action: "carrier-capacity", subaction: "edit-capacity", type: originPoint, carrierId: activeCarrier.id });
          }}
          icon={EditOutlinedIcon}
          buttonColor="blue"
        />
      </Box>
    </StyledTooltip>
  );
}

EditCapacityAction.propTypes = {
  activeCarrier: PropTypes.object,
  originPoint: PropTypes.string,
  lane: PropTypes.object.isRequired,
  actionCallback: PropTypes.func.isRequired
};